// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__33CxW","inner":"Form_inner__1Nc4k","range":"Form_range__2CG_b","name":"Form_name__3ZM43","actions":"Form_actions__ut4Vq"};